import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import api from './api-client'
import notify from './notifications-helper'
import Spinner from './spinner'

export const RunSixValuesMigration = () => {
  const [saving, setSaving] = useState(false)
  const dispatch = useDispatch()

  return (
    <button
      type="button"
      className="btn btn-danger"
      disabled={saving}
      onClick={() => {
        const proceed = window.confirm([
          'This will run the Six Values migration and then rescore all companies and user scores.',
          'It may take a long time and can cause load on the system.',
          'Are you sure you want to proceed?'
        ].join('\n\n'))

        if (!proceed) return

        setSaving(true)
        api.post('/api/admin/migrations/six-values/run', {})
          .then(() => {
            dispatch(notify.success({ message: 'Six Values migration started (running in background).' }))
          })
          .catch((ex) => {
            console.error(ex)
            dispatch(notify.error({ message: 'Failed to start Six Values migration.' }))
          })
          .finally(() => {
            setSaving(false)
          })
      }}
    >
      Run Six Values Migration {saving && <Spinner />}
    </button>
  )
}

export default RunSixValuesMigration

